var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid talent-query-page" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("img", {
        staticClass: "banner",
        attrs: { src: require("@/assets/img/query.png"), alt: "" },
      }),
      _c("div", { staticClass: "title" }, [_vm._v("查詢人才")]),
      _c(
        "div",
        {
          staticClass: "search-input-wrap",
          staticStyle: { "margin-bottom": "10px" },
        },
        [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.trim",
                value: _vm.QueryKeyword,
                expression: "QueryKeyword",
                modifiers: { trim: true },
              },
            ],
            attrs: {
              type: "text",
              placeholder: "請輸入關鍵字，如姓名、Email、手機、工作經歷、學歷",
            },
            domProps: { value: _vm.QueryKeyword },
            on: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.sendQueryValue()
              },
              input: function ($event) {
                if ($event.target.composing) return
                _vm.QueryKeyword = $event.target.value.trim()
              },
              blur: function ($event) {
                return _vm.$forceUpdate()
              },
            },
          }),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            "text-align": "left",
            "font-size": "15px",
            "margin-bottom": "10px",
          },
        },
        [
          _vm._v(
            " ※ 如要查詢人才姓名含「黃」與「王」任一個關鍵字的資料，便可使用「黃|王」的語法進行查詢。 "
          ),
        ]
      ),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          staticStyle: { "margin-left": "10px" },
          attrs: { type: "button" },
          on: { click: _vm.sendQueryValue },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Search")) + " ")]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "searchExplanModal",
            tabindex: "-1",
            "aria-labelledby": "exampleModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._v(" 進階搜尋說明 "),
                  _c(
                    "div",
                    {
                      staticStyle: { float: "right" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.showTornadoExplanModal.apply(
                            null,
                            arguments
                          )
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "0.8em" } }, [
                        _vm._v("關於進階搜尋"),
                      ]),
                      _c("span", { staticClass: "explanation" }, [_vm._v("?")]),
                    ]
                  ),
                ]),
                _vm._m(0),
                _vm._m(1),
              ]),
            ]
          ),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal fade",
          attrs: {
            id: "tornadoExplanModal",
            tabindex: "-1",
            "aria-labelledby": "exampleModalLabel",
            "aria-hidden": "true",
          },
        },
        [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _vm._v("進階查詢"),
                ]),
                _vm._m(2),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" 關閉 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: { click: _vm.enableFunction },
                    },
                    [_vm._v(" 開通此功能 ")]
                  ),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "tip-title" }, [_vm._v("1.複合式查詢")]),
      _c("div", { staticClass: "tip-sub-title" }, [_vm._v("布林運算式查詢")]),
      _c("div", { staticClass: "tip-sub-desc" }, [
        _vm._v(
          " 在查詢條件內使用布林符號「&」(AND運算)、「|」(OR運算)及「!」(NOT運算)，將可以使得查詢結果更為精準。 "
        ),
      ]),
      _c("table", { staticClass: "tip-table" }, [
        _c("tbody", [
          _c("tr", [_c("th", [_vm._v("搜尋")]), _c("th", [_vm._v("說明")])]),
          _c("tr", [
            _c("td", [_vm._v("&")]),
            _c("td", [
              _vm._v(
                " 如要查內文同時含有「蛋捲」與「冰淇淋」兩個關鍵字的資料，便可使用「蛋捲&冰淇淋」的語法進行查詢。 "
              ),
            ]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("|")]),
            _c("td", [
              _vm._v(
                " 如要查內文同時含有「蛋捲」與「冰淇淋」任一個關鍵字的資料，便可使用「蛋捲|冰淇淋」的語法進行查詢。 "
              ),
            ]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("!")]),
            _c("td", [
              _vm._v(
                " 如要查內文含有關鍵字「蛋捲」但不包含關鍵字「冰淇淋」的資料，便可使用「蛋捲!冰淇淋」的語法進行查詢。 "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "tip-sub-title" }, [_vm._v("中文萬用字元")]),
      _c("div", { staticClass: "tip-sub-desc" }, [
        _vm._v(
          " 欲使用不完整的資訊查詢時，可用「?」代替一個字，如輸入「?捲風」、「龍捲?」均能查詢「龍捲風」的相關資訊。或者所知的資訊更不完整時，可用「*」代替零到多個字進行查詢，如：輸入「tor*」進行查詢時，可搜尋出「tornado」、「torch」、或「torment」等相關結果 "
        ),
      ]),
      _c("div", { staticClass: "tip-title" }, [_vm._v("2.搜尋模式")]),
      _c("table", { staticClass: "tip-table" }, [
        _c("tbody", [
          _c("tr", [
            _c("th", [_vm._v("模式")]),
            _c("th", [_vm._v("說明")]),
            _c("th", [_vm._v("範例")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("完全符合")]),
            _c("td", [_vm._v("會根據輸入的關鍵字進行完全比對")]),
            _c("td", [_vm._v("輸入「文管」，能完全符合「文管」的關鍵字")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("模糊搜尋")]),
            _c("td", [_vm._v("可搜尋出語意相近的資訊")]),
            _c("td", [
              _vm._v("輸入「文建會」可以查到「文化建設委員會」的搜尋結果"),
            ]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("英文詞性代換")]),
            _c("td", [
              _vm._v(
                " 針對英文因詞性、時態不同產生字尾變化，進行自動擴展及替換 "
              ),
            ]),
            _c("td", [_vm._v("輸入「swimming」能找到「swim」")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("同音字搜尋")]),
            _c("td", [_vm._v("會搜尋出中文拼音相同的詞彙")]),
            _c("td", [_vm._v("輸入「臺灣」，能同時也找到「台灣」的內容")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("同義詞搜尋")]),
            _c("td", [_vm._v("也會搜尋出與關鍵字同義的字詞結果")]),
            _c("td", [_vm._v("輸入「製造」，能同時也找到「製作」")]),
          ]),
          _c("tr", [
            _c("td", [_vm._v("簡繁對譯搜尋")]),
            _c("td", [
              _vm._v(
                " 會進行繁體與簡體轉換，並使用繁體關鍵字與簡體關鍵字進行搜尋 "
              ),
            ]),
            _c("td", [_vm._v("輸入「印表機」，能同時也找到「打印机」")]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v(" 關閉 ")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("div", { staticClass: "desc" }, [
        _c("span", [
          _vm._v(" 尚未開通此功能"),
          _c("br"),
          _vm._v(
            " 套用龍捲風加值搜尋時，可額外搜尋技能專長、證照、學校、科系、地址"
          ),
          _c("br"),
          _vm._v(" 讓您的搜尋結果更加精確。"),
          _c("br"),
          _vm._v(" 歡迎點選下方按鈕開通此功能。 "),
        ]),
      ]),
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: {
          src: require("@/assets/img/explan/tornado/messageImage_01.jpg"),
          alt: "",
        },
      }),
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: {
          src: require("@/assets/img/explan/tornado/messageImage_02.jpg"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }